import React, { FC, useCallback } from 'react';

import { Minus } from '@yandex-360/iconostasis/dist/icons/Minus';
import { Plus } from '@yandex-360/iconostasis/dist/icons/Plus';
import { Button as OrbButton } from '@yandex-360/orb-components/dist/components/Button';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../../../shared/helpers/i18n';
import { ZOOM_BUTTON_STEP } from '../../constants';
import { selectCanZoomIn, selectCanZoomOut, selectSharingZoom, selectZoomLevelPercent } from '../../selectors';
import type { SharingZoomController } from '../../SharingZoomController';
import styles from './styles.css';

interface Props {
    controller: SharingZoomController;
}

export const ZoomControls: FC<Props> = ({ controller }) => {
    const { scale, tx, ty } = useSelector(selectSharingZoom);
    const zoomLevelPercent = useSelector(selectZoomLevelPercent);
    const canZoomIn = useSelector(selectCanZoomIn);
    const canZoomOut = useSelector(selectCanZoomOut);

    const handleZoomIn = useCallback(() => {
        controller.zoom(scale + ZOOM_BUTTON_STEP, tx, ty, true);
    }, [controller, scale, tx, ty]);

    const handleZoomOut = useCallback(() => {
        controller.zoom(scale - ZOOM_BUTTON_STEP, tx, ty, true);
    }, [controller, scale, tx, ty]);

    return (
        <div className={styles.root}>
            <OrbButton
                view="neutral"
                size="md"
                className={styles.zoomButton}
                onPress={handleZoomIn}
                isDisabled={!canZoomIn}
                aria-label={i18n('share-screen', 'zoom-in')}
                icon={<Plus />}
            />
            <Text className={styles.zoomLevel} typography="body-md-medium" color="primary">
                {zoomLevelPercent}%
            </Text>
            <OrbButton
                view="neutral"
                size="md"
                className={styles.zoomButton}
                onPress={handleZoomOut}
                isDisabled={!canZoomOut}
                aria-label={i18n('share-screen', 'zoom-out')}
                icon={<Minus />}
            />
        </div>
    );
};
